import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TicketsPage from './pages/TicketsPage';
import CreateTicketPage from './pages/CreateTicketPage';
import TicketDetailPage from './pages/TicketDetailPage';
import WarehousePage from './pages/WarehousePage';
import ItemsPage from './pages/ItemsPage';
import PurchasingPage from './pages/PurchasingPage';
import InvoicesPage from './pages/InvoicesPage';
import UsersPage from './pages/UsersPage';
import LocationsPage from './pages/LocationsPage';
import BankAccountsPage from './pages/BankAccountsPage';
import TransferPage from './pages/TransferPage';
import SchedulePage from './pages/SchedulePage';
import ArchivePage from './pages/ArchivePage';
import StockFlowPage from './pages/StockFlowPage';
import SystemHealthPage from './pages/SystemHealthPage';
import SlaDashboardPage from './pages/SlaDashboardPage';

import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tickets"
              element={
                <ProtectedRoute>
                  <TicketsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tickets/new"
              element={
                <ProtectedRoute>
                  <CreateTicketPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tickets/:ticketId"
              element={
                <ProtectedRoute>
                  <TicketDetailPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/archive"
              element={
                <ProtectedRoute requiredPermission="view_receipt_archive">
                  <ArchivePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/schedule"
              element={
                <ProtectedRoute>
                  <SchedulePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/warehouse"
              element={
                <ProtectedRoute requiredPermission="view_warehouse">
                  <WarehousePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/stock-flow"
              element={
                <ProtectedRoute requiredPermission="view_warehouse">
                  <StockFlowPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/system-health"
              element={
                <ProtectedRoute>
                  <SystemHealthPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sla-dashboard"
              element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <SlaDashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/transfer"
              element={
                <ProtectedRoute requiredPermission="transfer_stock">
                  <TransferPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/items"
              element={
                <ProtectedRoute requiredPermission="manage_items">
                  <ItemsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/purchasing"
              element={
                <ProtectedRoute anyOfPermissions={['submit_purchase_request','manage_purchasing','approve_purchase_request','order_purchase_request','receive_purchase_request']}>
                  <PurchasingPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/invoices"
              element={
                <ProtectedRoute anyOfPermissions={['view_invoices','generate_invoice','mark_paid_invoice']}>
                  <InvoicesPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute requiredPermission="manage_users">
                  <UsersPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/locations"
              element={
                <ProtectedRoute requiredPermission="manage_locations">
                  <LocationsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/bank-accounts"
              element={
                <ProtectedRoute anyOfPermissions={['manage_bank_accounts','view_invoices','generate_invoice']}>
                  <BankAccountsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
